export const ka = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'ტექსტი',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'დაამატეთ კალათში',
  ADD_TEMPLATE: 'დაამატეთ შაბლონი',
  ADJUST_SIZE_KEY: 'მოარგეთ ზომა',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'ქვევით გასწორება',
  ALIGN_CENTER_KEY: 'უერთდებიან ცენტრს',
  ALIGN_KEY: 'გასწორება',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'გასწორება შუა',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'ყველაზე გასწორება',
  ALL_TAB_TITLE_KEY: 'ყველა',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'იხილეთ შიგთავსი და აირჩიეთ სურათები თქვენი დიზაინისთვის, ან ატვირთეთ საკუთარი',
  BASIC_HELPER_INSTRUCTION2_KEY: 'იხილეთ თქვენი დიზაინი, დაარეგულირეთ დეტალები',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'პროექტში ცვლილებებისთვის დიზაინში დაამატეთ სხვა ელემენტები',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'შესაკვეთად დაასრულეთ დიზაინი, შეამოწმეთ და დააჭირეთ შემდეგს.',
  BACK_KEY: 'უკან',
  BACKGROUND_KEY: 'ფონი',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY: 'ამ კატეგორიაში არ არის შთაგონებები',
  BRING_TO_FRONT_KEY: 'წინ გადმოტანა',
  CANCEL_TEXT_KEY: ' გაუქმება ',
  CENTIMETERS_KEY: 'სანტიმეტრი',
  CM_KEY: 'სმ.',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'აირჩიეთ ფაილი',
  CITY: 'City',
  CLEAR_ALL_KEY: 'წაშლა',
  CLEAR_COLOR_KEY: 'Clear Color',
  CLOSE_WINDOW_KEY: 'Close window',
  CLEAR_ALL_OBJECTS: 'ყველა ობიექტის წაშლა',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE: 'წაიშლება ყველა ობიექტი თქვენი ფონიდან.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'ფერი',
  CONTINUE_KEY: 'გაგრძელება...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'სმ',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'დიზაინი',
  DELETE_KEY: 'წაშლა',
  DOCUMENT_COLORS: 'დოკუმენტის ფერები',
  DONE: 'Done!',
  DONE_KEY: 'შესრულებულია',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'ჩამოტვირთვა',
  DOWNLOAD_APP_TITLE_KEY: 'თქვენ შეგიძლიათ აპლიკაციის ჩამოტვირთვა აქ:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox -დან იმპორტი',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime ძიება',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime სურათები',
  DUPLICATE_KEY: 'ასლი',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'დიზაინის რედაქტირება',
  EDIT_LOWERCASE_KEY: 'რედაქტირება',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT: 'სამწუხაროდ შეცდომაა. სცადეთ მოგვიანებით.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'უკაცრავად, შეცდომაა ატვისთული PDF ფაილის გახსნისას.',
  EMAIL_KEY: 'ელ-ფოსტა',
  EMAIL_ADDRESS_KEY: 'ელ-ფოსტის მისამართი:',
  EMAIL_CHECKBOX_MESSAGE:
    'ვიცი რომ ამ პიროვნებისთვის გასაგებია რომ მიიღებს ელ-ფოსტას HP -ისგან ჩემთვის, ამ მომსახურების მომწოდებლის სახელით.',
  EXTRA_INFO_KEY: 'დამატებითი ინფორმაცია',
  EMAIL_NOTIFICATION:
    'თქვენ მიიღებთ შეტყობინებას ელ-ფოსტაზე. გთხოვთ, დაელოდოთ დამუშავებას.',
  EMAIL_DIALOG_MESSAGE: 'შეიყვანეთ ელ-ფოსტა ვისთანაც დიზაინის გაზიარება გსურთ.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'არსებული საქაღალდე',
  FACEBOOK_KEY: 'Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'გადახდამდე დარწმუნდით ყველა არჩეული საგნის სისწორეში',
  FINAL_CHECK_TITLE_KEY: 'საბოლოო შემოწმება',
  FINISH_KEY: 'დასრულება',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'მოტრიალება',
  FOR_KEY: 'ამისთვის',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'საძიებო სიტყვები:',
  FOLDER_NAME: 'საქაღალდის სახელი',
  FOLDER_NAME_KEY: 'საქაღალდე:',
  FOLDER_ALREADY_EXIST_KEY: 'ფოლდერი უკვე არსებობს',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'დიახ, გასაგებია',
  GROUP_ALL_KEY: 'დააჯგუფეთ',
  GROUP_SCALE: 'სკალირებული ჯგუფი',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'მიანიჭეთ სახელი',
  HEIGHT_KEY: 'სიმაღლე',
  HELP_KEY: 'დახმარება',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'სურათები',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'იმპორტი',
  INCHES_COLUMN_HEADER_KEY: 'ინჩიs',
  INCHES_KEY: ' ინჩი',
  INCHES_UNIT_STRING_KEY: 'ინ.',
  INVALID_EMAIL_ADDRESS_KEY: 'ელ-ფოსტა არასწორია',
  INVALID_INFO_KEY: 'Please enter details.',
  INVALID_NAME_KEY: 'სახელი არასწორია',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'უკაცრავად, თქვენ მიერ არჩეული ფაილი დიდია. ფაილის მაქსიმალური ზომაა 500mb.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'უკაცრავად, ფაილის ფორმატი არასწორია. მისაღებია pdf, jpg, png, svg და tif.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'ენა',
  LASTNAME: 'Last name',
  LEARN_MORE: 'მეტი',
  LEARN_THE_BASICS_KEY: 'საფუძვლები',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'ვებ-გვერდის მოხმარებით თქვენ ეთანხმებით შეზღუდვას',
  LEGAL_FOOTER_MESSAGE2_KEY: 'საიტი შეესაბამება',
  LEGAL_FOOTER_MESSAGE3_KEY: 'და',
  LENGTH_STRING_IN_INCHES_KEY: 'ინ',
  LINKED_IN_KEY: 'LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'შიგთავსის სანახავად გთხოვთ, ჩამოტვირთეთ LinkReader აპლიკაცია.',
  LOADING_KEY: 'იტვირთება...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'ჩაკეტვა',
  LOGIN_KEY: 'სისტემაში შესვლა',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'შესვლა Dreamstime- ში ',
  LOGOUT_KEY: 'სისტემიდან გასვლა',
  MATERIAL_TITLE_KEY: 'მასალა',
  MATERIAL_STRING_KEY: 'მასალა',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'ფონი არ შეიძლება დაპატარავდეს, რადგან თქვენ მიაღწიეთ მინიმალური სიმაღლს ან სიგანეს რომელიც საჭიროა თქვენი კედლის დასაფარად.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'მოდელი',
  MORE_INFO_TEXT_KEY: 'დამატებითი ინფორმაცია',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'სახელი:',
  NEXT_BUTTON_TITLE_KEY: 'შემდეგი',
  NEW_FOLDER_KEY: 'ახალი საქაღალდე',
  NO_SHADOW_KEY: 'ჩრდილის გარეშე',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'შეუკვეთეთ ნიმუში',
  ORDER_SAMPLE: 'ნიმუშის შეკვეთა',
  ORDER_SAMPLE_INFOLABEL_1:
    'აირჩიეთ სურათის ნაწილი რომლის ნიმუშის შეკვეთაც გსურთ',
  ORDER_SAMPLE_INFOLABEL_2:
    'თქვენ მიიღებთ ელ-ფოსტას თქვენი პროექტის ნამდვილი ზომის გამოსახულებით',
  ORDER_SAMPLE_INFOLABEL_3: 'დაგეხმარებათ ხარისხის და გამოსახულების შეფასებაში',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'მოითხოვეთ ნიმუში',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'მიიღეთ ელ-ფოსტა, რომელიც შეიცავს თქვენი პროექტის რეალურ ზომას ხარისხის და გამოსახულების შესაფასებლად.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'პაროლი',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'სტრუქტურის დიზაინი',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'მე მაქვს საავტორო უფლება ამ სურათზე და ვეთანხმები',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'ფიქსელი',
  PININTEREST_KEY: 'Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'სმ',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'i.e Some important things you need to communicate to the print shop',
  PLACEHOLDER_INCHES_STRING_KEY: 'ინ',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'მდებარეობა',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'შეინახეთ თქვენი პროექტი',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'პროექტში ცვლილებებია, რომლებიც გაგრძელებამდე საჭიროებს შენახვას.',
  PRICE_COLUMN_HEADER_KEY: 'ფასი',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'მუშავდება...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'წინასწარი ესკიზი',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'პროექტის სახელი',
  PROJECT_NAME: 'პროექტის სახელი:',
  PROJECT_ALREADY_EXIST_KEY: 'პროექტი უკვე არსებობს',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'პროექტი უკვე არსებობს',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'ფოლდერი უკვე არსებობს',
  PIXELATION_WARNING_KEY: 'Pixelation Warning',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Due to the resolution of your uploaded image, your skin may be blurred or distorted. To ensure there is no blur, please upload an image with a good quality and avoid stretching the image. If you are happy with the preview and would like to proceed, please continue to submit.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: '*Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'სავალდებულო',
  RECOLOR_KEY: 'გადაღებვა',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'გადაღებვა',
  REQUEST_SAMPLE_KEY: 'მოითხოვეთ ნიმუში',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'ზომის შეცვლა თვითნებურად',
  RESIZE_PROPORTIONALLY_KEY: 'ზომის შეცვლა პროპორციულად',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Request for Quotation',
  RIGHT_LOGO_TEXT_KEY: 'by',
  ROTATE_KEY: 'მოტრიალება',
  ROTATE_LEFT_KEY: 'მოტრიალება90° მარცხნივ',
  ROTATE_RIGHT_KEY: 'ROTმოტრიალება 90° მარჯვნივ',
  ROTATION_KEY: 'მოტრიალება',
  ROWS_COLUMN_LABEL_STRING_KEY: 'რიგები და სვეტები',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'შენახვა',
  SAVING_KEY: 'შენახვა...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'შაბლონის შენახვა',
  SAVE_DIALOG_TITLE: 'შეინახეთ თქვენი პროექტი',
  SAVE_PROJECT_NAME_KEY: 'თავდაპირველად, შეინახეთ თქვენი პროექტიt',
  SAVEDIALOG_MESSAGE:
    'პროექტის შესანახად გაიარეთ სისტემაში რეგისტრაცია.თუ არ გაქვთ ანგარიში, ჩვენ დაგეხმარებით შექმნაში. თქვენი ნამუშევარი არ დაიკარგება.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'სკალირება',
  SCALE_ALL_KEY: 'სკალირება',
  SCALE_TO_FILL_KEY: 'ზომაში შევსება',
  SEARCH_BUTTON_TITLE_KEY: 'ძებნა',
  SELECT_CUSTOM_SIZE_KEY: 'აირჩიეთ თქვენი ზომა',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'ძებნა',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'აირჩიეთ პოსტერის ზომა',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'გამომიგზავნეთ საინსტალაციო ინსტრუქცია',
  SEND_TO_BACK_KEY: 'უკან გადაყვანა',
  SEND_KEY: 'გაგზავნა',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'ზომის შეყვანა',
  SETTINGS_KEY: 'პარამეტრები',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'გაზიარება',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'კვ. ფტ.',
  SQM_UNIT_STRING_KEY: 'მ²',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'წარუდგინოს',
  SHARE_LINK_LABEL: 'აირჩიეთ ბმული რომლის გაზიარებაც გსურთ',
  SHARE_EDIT_LINK: 'ბმულის რედაქტირება',
  SHARE_VIEW_LINK: 'ბმულის ნახვა',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT: '* ნახვის მანძილის შეცვლა შესაძლებელია პარამეტრებიდან.',
  TERMS1_KEY: 'პირობები',
  TERMS2_KEY: 'HP კონფიდენციალურობის განცხადება',
  TERMS3_KEY: 'HP პერსონალური მონაცემებზე უფლებათა ცნობა',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'გამოყენების პირობები.',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'ფილა',
  TOTAL_KEY: 'ჯამი',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'გმადლობთ',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',
  TWITTER_KEY: 'Twitter',
  UNLOCK_KEY: 'ბლოკის მოხსნა',
  UNGROUP_KEY: 'დაჯგუფების გახსნა',
  UPDATE_TEXT_KEY: 'განახლება',
  UPLOAD_KEY: 'სურათის ატვირთვა',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'მომხმარებლის სახელი',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'ფილების მოხსნა',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'მოქმედების ვადა',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'VAT',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'ნახვა Fotolia© -ში',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'იხილეთ დიზაინის დეტალები',
  VIEW_DESIGNER_PROFILE_KEY: 'იხილეთ დიზაინერის პროფილი',
  VIEW_PRICE_KEY: 'ფასის ნახვა',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'კედლის პოსტერი',
  WALL_SIZE_TEXT_KEY: 'კედლის ზომა',
  WARNING_KEY: 'გაფრთხილება',
  WEBSITE: 'Website',
  WIDTH_KEY: 'სიგანეh',
  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'თქვენი სახელი',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'პროექტი:',
  PROJECT_NAME_ERROR_TEXT: 'შეიყვანეთ თქვენი პროექტის სახელი.',
  PROJECT_FOLDER_ERROR_TEXT: 'შეიყვანეთ თქვენი პროექტის საქაღალდის სახელი.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'ნახვის მინიმალური დისტანცია',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'არ არის ოცნება დრო',
  NO_ELEMENT_ERROR_MESSAGE: 'ელემენტი არ მოიძებნა.',
  NO_MORE_IMAGES_FOUND_KEY: 'აღარ მოიძებნა გამოსახულება',
  NO_PATTERN_ERROR_MESSAGE: 'ტექსტურა ნაპოვნი არ არის.',
  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'შეტყობინება:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    "You've scaled to a point where your printed image may look pixelated when viewing at {0} {1} * (current printed resolution is {2} dpi).",
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'ნახვის რეკომენდირებული მანძილი არის {0} {1}. თუ ეს არ არის მისაღები, გთხოვთ შეამციროთ ამ გამოსახულების მასშტაბი ან კედლის ზომა.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'სურათის რეკომენდირებული მინიმალური ზომა უნდა იყოს {0} x {1} ფიქსელი.',
  UPLOAD_STATUS: '{0}% of {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'მინიმალური ზომებია {0} (სიგანე) და {1} (სიმაღლე).',
  MINIMUM_HEIGHT_KEY: 'მინიმალური სიგანეა {0}.',
  MINIMUM_WIDTH_KEY: 'მინიმალური სიგანეა {0}.',
  MAXIMUM_DIMENSIONS_KEY:
    'მაქსიმალური გაფართოებაა {0} (სიგანე) და {1} (სიმაღლე).',
  MAXIMUM_WIDTH_KEY: 'მაქსიმალური სიგანე {0}.',
  MAXIMUM_HEIGHT_KEY: 'მაქსიმალური სიმაღლე {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY: 'შეიყვანეთ რიცხვითი ზომა ნულს ზევით.',
  PROCESSING_FAILED: 'დამუშავება ვერ მოხერხდა, სცადეთ მოგვიანებით',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'უკაცრავად, არ არის მრავალგვერდიანი PDF ფაილის მხარდაჭერა.',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'უკაცრავად, დაშიფრული PDFs არ არის მხარდაჭერილი.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'გაილის იმპორტი {0}  {1} -დან',
  RECOLORING_KEY: 'გადაღებვა...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  AUTHENTICATE_DIALOG_TITLE: 'შიგთავსი დაცულია პაროლით',
  AUTHENTICATE_FAILED_MESSAGE: 'ავტორიზაცია არ განხორციელდა!',
  DROPBOX_IMPORT_ERROR_HEADER: 'ფაილების იმპორტისას შეცდომაა',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'ინსპირაციის ეს შაბლონი შეიცავს ნაგულისხმევი ზომით 0} X {1} {2. თქვენი გვერდის ზომა ავტომატურად შეიცვლება ამ შაბლონის შესაფერისად.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Choose your laptop',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'First name',
  LAST_NAME_KEY: 'Last name',
  PHONE_NUMBER_KEY: 'Phone No.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: 'გთხოვთ შეიყვანოთ აუცილებელი ველი',
  ADDRESS_KEY: 'Address',
  INVALID_ADDRESS_KEY: 'Invalid address',
  CITY_KEY: 'City',
  INVALID_CITY_KEY: 'Invalid city',
  COUNTRY_KEY: 'Country',
  STATE_KEY: 'State',
  ZIP_KEY: 'Zip',
  INVALID_ZIP_KEY: 'Invalid zip code',
  ORDER_NUMBER: 'Order number',
  YOUR_DETAILS_KEY: 'თქვენი დეტალები',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  NOTICE_KEY: 'ცნობა:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'იმისთვის, რომ კომპიუტერის კანი სრულყოფილად მოერგოს თქვენს ადგილს, თქვენ უნდა აირჩიოთ შეძენის შესაბამისი ზუსტი მოდელი, როგორც ეს ინვოისში ჩანს.',
  RESTART_PROJECT_ALERT_TITLE: 'დაიწყეთ პროექტი ხელახლა?',
  DISCARD_ALERT_MESSAGE: 'თქვენი მიმდინარე პროექტი გაუქმდება',
  RESTART: ' ხელახლა დაწყება',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'გვერდის ზომა გაფრთხილება!',
  MODIFY_SIZE_WARNING:
    'თუ გსურთ ამ დიზაინის ზომის შეცვლა, შეგიძლიათ ამის გაკეთება "პარამეტრების" ჩანართში. დიზაინის ელემენტებმა შეიძლება მოითხოვონ რედაქტირება, სასურველი ზომების შესასრულებლად.',
  RANDOMIZE_KEY: 'რანდომიზაცია',
  MATERIAL_CHOICE_APPLIED: 'გამოყენებულია მასალის არჩევანი.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'ბლოკნოტი',
  CERTIFICATE_STRING: 'სერტიფიკატი',
  AUTHENTICITY_STRING: 'ნამდვილობა',
  PLEASE_WAIT: 'გთხოვთ მოიცადოთ',
  PROTECTING_YOUR_DATA: 'თქვენი მონაცემების დაცვა...',
  SEARCH_YOUR_LAPTOP_KEY: 'მოძებნეთ თქვენი ლეპტოპი', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'უი! ჩვენ ვერ ვიპოვნეთ ლეპტოპი თქვენი ძებნისთვის.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'სერიული ნომერი',
  LOCKED_PROJECT: 'დაბლოკილი პროექტი',
  LOCKED_MESSAGE:
    'შეკვეთილი პროექტის შეცვლა შეუძლებელია. მხოლოდ ნახვაა შესაძლებელია.',
  EXPIRED_PROJECT: 'ვადაგასული პროექტიt',
  EXPIRED_MESSAGE: 'პროექტი ვადაგასულია.',
  DELETED_PROJECT: 'წაშლილი პროექტი',
  DELETED_MESSAGE: 'პროექტი წაშლილია.',
  CHOOSE_GROUP_TYPE: 'აირჩიეთ {0} ტიპი',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'შეიყვანეთ რიცხვი ნულს ზევით.',
  SIZE_KEY: 'ზომა',
  DISTANCE_FROM_KEY: 'დაშორება',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'ავეჯიe',
  FIXTURES_KEY: 'ინვენტარი',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'მარცხენა',
  RIGHT_KEY: 'მარჯვენა',
  DELETE_WALL_KEY: 'კედლის წაშლა',
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'კედლის მაქსიმალური ზომა {0} კვ.{1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: 'კანვასის სიმაღლე აჭარბებს კედლის სიმაღლეს.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'კანვასის სიგანე აჭარბებს კედლის სიგანეს.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'მაქსიმალური სვეტების რაოდენობა ამ სიგანისთვისს არის {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'მაქსიმალური რიგების რაოდენობა ამ სიმაღლისთვის არის {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'კედლის სიგანე ნაკლებია კანვასის სიგანეზე.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY: 'კედლის მინიმალური სიგანეა {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY: 'კედლის მინიმალური სიმაღლეა {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'კედლის სიმაღლე ნაკლებია კანვასის სიმაღლეზე.',
  MAXIMUM_WALL_HEIGHT_KEY: 'კედლის მაქსიმალური სიმაღლე {0} {1}.',
  FINISHING_KEY: 'დასრულება',
  MIRROR_KEY: 'სარკე',
  NATURAL_KEY: 'ბუნებრივი',
  ROWS_KEY: 'რიგი',
  COLUMNS_KEY: 'სვეტი',
  DEFAULT_WALL_SIZE_KEY: 'კედლის საწყისი ზომა',
  EDIT_KEY: 'რედაქტირება',
  TOP_KEY: 'ზედა',
  BOTTOM_KEY: 'ქვემოთ'
};
